import { render, staticRenderFns } from "./NewMatrixStudyProfile.vue?vue&type=template&id=a0cbd568&"
import script from "./NewMatrixStudyProfile.vue?vue&type=script&lang=js&"
export * from "./NewMatrixStudyProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports